// @flow

import React from "react";
import SvgIcon, { type SvgIconProps } from "../SvgIcon";

const FilterSlash = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <svg viewBox="0 0 14.427 12">
            <path
                d="M.869.114a.528.528,0,0,0-.76.1A.578.578,0,0,0,.2,1L13.547,11.875a.528.528,0,0,0,.76-.1.578.578,0,0,0-.092-.79L9.16,6.871l3.616-4.6a.97.97,0,0,0,.117-1,.9.9,0,0,0-.816-.534H2.339a.887.887,0,0,0-.5.159Zm4.9,9.255a.755.755,0,0,0,.289.6L7.5,11.094a.7.7,0,0,0,.755.07.755.755,0,0,0,.4-.67V9.334L5.765,6.972Z"
                transform="translate(0.006 0.006)"
            />
        </svg>
    </SvgIcon>
);

export default FilterSlash;
